import { Box, Grid, Typography } from "@mui/material";
import { COLOR_PRIMARY, COLOR_SECONDARY } from "../../../constants";

export const DividerComponent = ({
  label,
  children,
}: {
  label: string;
  children?: any;
}) => {
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mt: 0.5,
          pb: 0.75,
          borderBottom: "1px solid #e6ebf2",
        }}
      >
        <Box
          sx={{
            width: 4,
            height: 18,
            borderRadius: 2,
            background: `linear-gradient(180deg, ${COLOR_PRIMARY}, ${COLOR_SECONDARY})`,
          }}
        />
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            color: COLOR_PRIMARY,
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Typography>
        {children ? (
          <Box
            sx={{
              ml: "auto",
              "& .ant-btn": {
                height: 26,
                padding: "0 10px",
                fontSize: 12,
                fontWeight: 600,
                borderRadius: 6,
                borderStyle: "solid",
                color: COLOR_SECONDARY,
                borderColor: `${COLOR_SECONDARY}66`,
                background: `${COLOR_SECONDARY}0F`,
              },
              "& .ant-btn:hover": {
                color: "#fff !important",
                background: `${COLOR_SECONDARY} !important`,
                borderColor: `${COLOR_SECONDARY} !important`,
              },
            }}
          >
            {children}
          </Box>
        ) : null}
      </Box>
    </Grid>
  );
};
